let ClientQuicksightURL = () => {
    let client = localStorage.getItem('customerNumber');

    switch (client) {
        case "1305":
            return {
                "BASE_QUICKSIGHT_DASHBOARD": '97bc1f04-472a-47f4-9e9a-ea0816f8cc3c',
                "DUMP_ANALYSIS": '7d409908-3d67-4ad8-993c-df072485ced8',
                "DAILY_PLACEMENT_DASHBOARD": '753fe275-ff89-451a-8400-3f56a9833f58'
            }
        case "1330":
            return {
                "BASE_QUICKSIGHT_DASHBOARD": '5851734f-eb04-4bc9-8505-abf297abca28',
                "PERFORMANCE_EFFICIENCY": '5992d873-1176-4e6b-b384-f56fbe259149',
                "ORDERS_REPORT" : 'a90ce6e4-a55d-4a43-b616-d3110195cccd',
                "USER_LOGIN_HISTORY" : '52c17550-0aa9-4bbb-9fc6-da7dedfb9ee3'
            }
        case "503":
            return {
                "DUMP_ANALYSIS": 'ba4831d9-6d96-411c-821c-354ef571c38d'

            }
        case "1123":
            return {
                "BASE_QUICKSIGHT_DASHBOARD": '881efdae-0fc5-41ae-ac0f-a82f72e07531',
                "ON_TIME_PLACEMENT_ANALYSIS": '881efdae-0fc5-41ae-ac0f-a82f72e07531',
                "VENDOR_ALLOCATION_STATUS": 'dc294c03-d5e6-41c4-a656-c4e13d0bb8c2'
            }
        case "1077":
            return {
                "TRIP_DISTANCE_ANALYSIS": '46561a82-5dc4-42cf-b183-bf0519089a3d',
            }
        case "1375":
            return {
                "BASE_QUICKSIGHT_DASHBOARD": 'f144d8b7-d25a-40b1-b05c-546ea87445b8',
                "MIS_REPORT": '74c02426-67b0-4103-bc02-96c20e70302c',
            }
        case "1568":
            return {
                "LR_DUMP_REPORT": 'cab39582-1660-4037-af9b-35aeee1ad55f',
                "PLACEMENT_ANALYSIS" : '400cb6cb-11fc-44da-a78c-677021c31988'
            }
        case "1413":
                return {
                    "LR_DUMP_REPORT": '299a7218-2f8c-4b8e-ae1a-5700e5363ff0',
                }
        case "1654":
                return {
                    "BASE_QUICKSIGHT_DASHBOARD": '60ddbdc2-151c-45ed-9edc-2fcabb938b2a',
                    "DUMP_DASHBOARD" : '7593d115-0698-42a0-a44c-d03de787b30a'
                }
        case "1166":
                return {
                    "RATE_ENGINE_EXCEPTION_REPORT": 'd456c126-f0a7-43ff-b92c-53b9f7b2551c',
                    "BASE_QUICKSIGHT_DASHBOARD":"54d4f6b4-8c7c-4907-9248-852ad23af4db"
                    }
        case "1562":
                return {
                    "MIS_REPORT": 'b9f257f6-95ee-4d2c-99d5-1e2a7349b3c6',
                    "BASE_QUICKSIGHT_DASHBOARD":"82dfc815-149f-4bda-aed9-70a89ec767c6"
                    }
        case "1922":
                return {
                    "MIS_REPORT": 'c1fafb9e-c954-475f-85bb-a7d40b97d5ed',
                    "DUMP_DASHBOARD":"b682dd65-81eb-4486-9f4a-235ebb338b49"
                    }
        case "549":
                return {
                    "LR_DUMP_REPORT": 'b1bb9481-4979-42f7-9bd7-0c760e9cf270',
                    }
        case "1931":
                return {
                    "LR_DUMP_REPORT": '30f318e7-b47d-4920-b6ca-de39230e7ce3',
                    }
        default: //1158 Client
            return {
                "BASE_QUICKSIGHT_DASHBOARD": '37967326-f86a-4aa9-82be-805104e3b9b3',
                "OFFER_VS_FINAL_PRICE": 'b0cbd14d-1183-4d7b-949f-fe6a72537776',
                "PARTNER_PERFORMANCE_DASHBOARD": '71b10faa-f5a4-434a-b633-a9ba7f3b8e87',
                "THC_DASHBOARD": 'c1fe226a-7fa9-4ee2-9b73-e7275cad38af'
            }
    }
}

export default ClientQuicksightURL();